import { createContext, useState } from "react";
import cookies from "js-cookie";

const LanguageContext = createContext({
  authToken: "",
  languageCodeHandler: () => {},
});

const retrieveStoredLanguageCode = () => cookies.get("i18next") || "el";

export const LanguageContextProvider = (props) => {
  const initialLanguageCode = retrieveStoredLanguageCode();

  const [languageCode, setLanguageCode] = useState(initialLanguageCode);

  const languageCodeHandler = (lngCode) => setLanguageCode(lngCode);

  const context = {
    languageCode,
    languageCodeHandler,
  };

  return (
    <LanguageContext.Provider value={context}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
